export const DROPZONE_VIRTUAL = 'virtual' as const;
export const DROPZONE_STANDARD = 'standard' as const;
